export default {
    ja: {
        heroImage: {
            date: '2025年10月3日(金)〜5日(日)、10日(金)〜13日(月・祝)、17日(金)〜19日(日)、23日(木)〜26日(日)\n' +
                '17:00〜21:00　最終入場 20:30',
            button: 'Full Movie',
            link: '',
        }
    },
    en: {
        heroImage: {
            date: 'October 3 (Fri)~ 5 (Sun), 10 (Fri)~ 12 (Sun), 13 (Mon / Holiday), ~17 (Fri)~ 19 (Sun),\n' +
                '23 (Thu)~ 26 (Sun)\n' +
                '17:00-21:00（last admission at 20:30）',
            button: 'Full Movie',
            link: '',
        }
    },
}